<template>
  <div class="main">
    <!--搜索-->

    <form action="/">
      <van-search
        v-model="condition"
        show-action
        placeholder="请输入您的城市"
        @search="onSearch"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </form>

    <div class="current">
      <h1 class="city-title">当前城市</h1>
      <span v-if="cityName">{{ cityName }}</span>
    </div>
    <div class="hot">
      <h1 class="city-title">热门城市</h1>
      <div class="citys">
        <div v-for="(city, index) of hotCitys" :key="index" @click="chooseHot(city)">{{ city }}</div>
      </div>
    </div>

    <div v-if="!cityList.length && !isSearch" class="placeholder">
      城市加载中<span class="dot">...</span>
    </div>
    <div v-if="!cityList.length && isSearch" class="placeholder">
      未找到您的城市
    </div>
    <div v-if="cityList.length && isSearch" class="container">
      <van-index-bar>
        <div v-for="(item, index) of cityList" :key="index">
          <van-index-anchor :index="item.letter" />
          <van-cell
            v-for="(list, i) of item.areaList"
            :key="i"
            :title="list.name"
            @click="chooseCity(index,i)"
          />
        </div>
      </van-index-bar>
    </div>
  </div>
</template>

<script>
import { getCityList } from '@/api/api'

export default {
  name: 'Position',
  data() {
    return {
      type: false,
      path: '',
      current: 0,
      condition: '',
      cityList: [],
      hotCitys: [
        '上海市',
        '北京市',
        '苏州市',
        '南京市',
        '成都市',
        '合肥市',
        '安阳市',
        '无锡市',
        '广州市',
        '深圳市',
        '大连市',
        '杭州市'
      ],
      isSearch: false,
      cityName: this.$store.getters.cityName
    }
  },
  created() {
    if (this.$route.query.type) {
      this.type = true
    }
    this.getCityList()
  },
  methods: {
    async getCityList() {
      const res = await getCityList({ condition: this.condition })
      this.cityList = res.data
      this.isSearch = true
    },
    onSearch() {
      this.cityList = []
      this.isSearch = false
      this.getCityList()
    },
    async chooseHot(city) {
      this.cityName = city
      await this.$store.dispatch('setCity', city)
      if (this.type) {
        await this.$store.dispatch('setType2', true)
      }
      this.$router.go(-1)
    },
    async chooseCity(index, i) {
      this.cityName = this.cityList[index].areaList[i].name
      await this.$store.dispatch('setCity', this.cityName)
      if (this.type) {
        await this.$store.dispatch('setType2', true)
      }
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.placeholder {
  text-align: center;
  margin-top: 400px;
  font-size: 32px;
  color: #fd6a42;
  font-weight: bold;
}

.dot {
  font-family: simsun;
}
:root .dot {
  display: inline-block;
  width: 3em;
  vertical-align: bottom;
  overflow: hidden;
}
@-webkit-keyframes dot {
  0% {
    width: 0;
    margin-right: 3em;
  }
  33% {
    width: 1em;
    margin-right: 2em;
  }
  66% {
    width: 2em;
    margin-right: 1em;
  }
  100% {
    width: 3em;
    margin-right: 0;
  }
}
.dot {
  -webkit-animation: dot 3s infinite step-start;
}

@keyframes dot {
  0% {
    width: 0;
    margin-right: 3em;
  }
  33% {
    width: 1em;
    margin-right: 2em;
  }
  66% {
    width: 2em;
    margin-right: 1em;
  }
  100% {
    width: 3em;
    margin-right: 0;
  }
}
.dot {
  animation: dot 1s infinite step-start;
}

.main {
  display: flex;
  flex-direction: column;
  width: 100vw;
  background: #ffffff;
  .current,
  .hot {
    margin: 0 auto;
    width: 690px;
  }
  .city-title {
    font-size: 28px;
    line-height: 90px;
    font-family: PingFang SC;
    font-weight: 800;
    color: rgba(51, 51, 51, 1);
  }
  .current {
    display: flex;
    height: 90px;
    align-items: center;
    border-bottom: 1px solid #f2f2f2;
    span {
      margin-left: 30px;
      padding: 0 5px;
      height: 34px;
      background: rgba(253, 106, 66, 1);
      border-radius: 6px;
      text-align: center;
      line-height: 34px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 800;
      color: rgba(255, 255, 255, 1);
    }
  }
  .hot {
    .citys {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      div {
        margin-bottom: 30px;
        width: 210px;
        height: 70px;
        line-height: 70px;
        text-align: center;
        background: rgba(242, 242, 242, 1);
        border-radius: 12px;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 800;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}

.container {
  display: flex;
  flex-direction: column;
}

.body {
  display: flex;
  flex-direction: column;
}

.title {
  line-height: 40px;
  background: rgba(235, 235, 235, 1);
  font-size: 28px;
  font-family: PingFang-SC-Bold;
  font-weight: bold;
  color: rgba(102, 102, 102, 1);
}

.title p {
  margin-left: 30px;
}

.region {
  margin: 0 30px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(235, 235, 235, 1);
}

.region div p {
  display: flex;
  flex-direction: column;
  line-height: 84px;
  font-size: 28px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
}

.region:last-child {
  border-bottom: 0;
}
</style>

<style>
.van-index-bar__index {
  font-size: 10px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
  line-height: 18px;
}
</style>
